export default "__VITE_ASSET__1f1390a1__$_?component__"